var $ = jQuery.noConflict();
$(document).ready(function () {

  // Add item to bundle
  $("button.product-item-atb").click(function (t) {
    t.preventDefault();
    var e = $(this).parents(".product-item-option"),
        d = e.find('.product-item-qty input[name="quantity"]').attr("data-varid"),
        i = e.find('.product-item-qty input[name="quantity"]').val(),
        a = e.find(".product-item-old-price").attr("data-price"),
        o = e.find(".product-item-new-price").attr("data-price"),
        n = e.find(".product-item-title").text(),
        r = e.find("img.product-item-img").attr("src"),
        t = $(".footer-bundle-items-update li.bndl_list_item").length;

    $(".footer-bundle-items-update").append(
      '<li class="bndl_list_item product-form--root" data-count="' +
        i +
        '" data-varid="' +
        d +
        '"><div class="add-in-items" data-oldprice="' +
        a +
        '" data-newprice="' +
        o +
        '" data-itemnumber="' +
        t +
        '"><div class="add-in-items_img"><img src="' +
        r +
        '" alt="' +
        n +
        '"></div><div class="add-in-items_title"><h4 class="footer-bundle-prod_title">' +
        n +
        '</h4><button type="button" class="bundle-prod_remove">x</button></div></div></li>'
    );

    n = $(".footer-bundle-items-update li.bndl_list_item").length;

    // Update visibility and button states
    if (n >= 1) {
      e.find(".product-item-qty").removeClass("hidden");
      e.find(".product-item-atc").addClass("hidden");
      e.find('.product-item-qty input[name="quantity"]').val(1);
    }

    if (n >= 4) {
      $("button.product-item-atb").attr("disabled", "disabled");
      $("button.product-item-plus-qty").attr("disabled", "disabled");
      $("span.bundle-footer-atc-text").text("Add to cart");
      $("button.bundle-footer-atc").removeAttr("disabled");
    } else {
      $('button.product-item-atb[data-avail="yes"]').removeAttr("disabled");
    }

    // Price calculation
    var l = 0;
    $(".footer-bundle-items-update li.bndl_list_item").each(function () {
      l += parseFloat($(this).find(".add-in-items").attr("data-newprice"));
    });

    if (n <= 3) {
      $(".total_bundle_price .total_bundle_oldprice").hide();
      $(".total_bundle_price .total_bundle_price-new").text("$" + l.toFixed(2)).show();
    } else {
      $(".total_bundle_price .total_bundle_oldprice").text("$" + l.toFixed(2)).show();
    }

    // Step progress
    if (n >= 3 && n <= 5) $(".footer-bundle-items .step-second").removeClass("hidden");
    if (n >= 6 && n <= 8) $(".footer-bundle-items .step-third").removeClass("hidden");
    if (n >= 9 && n <= 12) $(".footer-bundle-items .step-fourth").removeClass("hidden");
  });

  // Handle ATC button
  $(document).on("click", "button.bundle-footer-atc", function (t) {
    $(".bundle-footer-atc .bundle-footer-atc-text").addClass("hidden");
    $(".bundle-footer-atc .bundle-footer-atc-spinner").removeClass("hidden");
    t.preventDefault();

    var bundleId = Math.floor(1e9 + 9e9 * Math.random());
    var ShopifyQueue = [];
    $(".footer-bundle-items-update li.bndl_list_item").each(function () {
      var variantId = $(this).attr("data-varid");
      ShopifyQueue.push({ variantId: variantId, quantity: 1 });
    });

    function ShopifyMoveAlong() {
      if (ShopifyQueue.length) {
        var item = ShopifyQueue.shift();
        var postData =
          "id=" + item.variantId +
          "&quantity=" + item.quantity +
          "&properties%5BBundle Id%5D=" + bundleId;

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: postData,
          success: function () {
            ShopifyMoveAlong();
          },
          error: function () {
            ShopifyMoveAlong();
          }
        });
      } else {
        // Apply Discount
        $.ajax({
          type: "POST",
          url: "/discount/BUY3GET1FREEPRODUCT",
          success: function () {
           refreshCartDrawer();
          },
          error: function () {
           refreshCartDrawer();
          }
        });
      }
    }
    ShopifyMoveAlong();
  });
    function refreshCartDrawer() {
          fetch(`/?section_id=cart-drawer`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                const drawer = document.querySelector("cart-drawer");
                drawer.innerHTML = resJSON["cart-drawer"];
                drawer.classList.remove("is-empty");
                for (const selector of selectors) {
                  const targetElement = document.querySelector(selector);
                  const sourceElement = html.querySelector(selector);
                  if (targetElement && sourceElement) {
                    targetElement.replaceWith(sourceElement);
                  }
                }
              })
              .catch((e) => {
                console.error(e);
              });
 
    }

});
